module.exports = __webpack_public_path__ + "img/lender_benefit_sharing_mobile.7e6e604b.jpg";